const faqs = [
  {
    q: 'Quels sont les signes que ma baie coulissante a besoin d\'une réparation ?',
    a: 'Plusieurs signes ne trompent pas : la baie est dure à ouvrir ou fermer, elle coince en milieu de course, elle émet un bruit de raclement ou de grincement, ou encore elle déraille de son rail. Si vous constatez l\'un de ces symptômes, il est temps de faire intervenir un professionnel avant que la panne ne s\'aggrave et n\'endommage le dormant ou le cadre.',
  },
  {
    q: 'Intervenez-vous le week-end et les jours fériés dans l\'Hérault ?',
    a: 'Oui, DFPRO Hérault intervient 7j/7, y compris les week-ends et jours fériés. Nous savons qu\'une baie coulissante bloquée ou un volet roulant en panne n\'attend pas. Nos techniciens se déplacent dans tout l\'Hérault — Montpellier, Sète, Agde, Béziers, Frontignan et toutes les communes du littoral — sous 24 à 48h après votre appel.',
  },
  {
    q: 'Proposez-vous un devis avant toute intervention ?',
    a: 'Absolument. Le devis est gratuit et sans engagement. Notre technicien se déplace à votre domicile ou dans vos locaux, diagnostique précisément la panne, et vous remet un devis détaillé. Vous décidez ensuite en toute transparence. Aucune intervention n\'est réalisée sans votre accord préalable.',
  },
  {
    q: 'Quelles marques de baies coulissantes réparez-vous ?',
    a: 'Nous intervenons sur toutes les marques de menuiseries aluminium : Technal, Sepalumic, Schüco, K-Line, Wicona, Kawneer, SAPA, et bien d\'autres. Nos techniciens sont formés aux spécificités de chaque fabricant et disposent des pièces détachées compatibles pour une réparation dans les règles de l\'art.',
  },
  {
    q: 'La garantie de 10 ans couvre-t-elle toutes les réparations ?',
    a: 'Oui, l\'ensemble de nos réparations de menuiseries est couvert par notre garantie décennale. Cela inclut le remplacement des roulettes et galets, la réparation des rails, le réglage des baies, la réparation des serrures et crémones, et le remplacement de vitrage. Nous utilisons exclusivement des pièces de qualité professionnelle.',
  },
  {
    q: 'Combien de temps dure une intervention typique sur une baie coulissante ?',
    a: 'La durée dépend de la nature de la panne. Un changement de roulettes ou galets prend généralement 1 à 2 heures. Un remplacement de rail ou de vitrage peut nécessiter une demi-journée. Le remplacement complet d\'une baie coulissante se fait en une journée. Notre technicien vous donnera une estimation précise lors du diagnostic.',
  },
];

export default function FAQSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Questions fréquentes
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg">
            Les réponses à vos questions sur la réparation de baie coulissante dans l'Hérault.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-background-200">
              <summary className="flex items-center justify-between p-5 cursor-pointer font-heading font-semibold text-primary-500 text-base list-none">
                {faq.q}
                <span className="w-6 h-6 flex items-center justify-center shrink-0 ml-3 text-accent-500 group-open:rotate-180 transition-transform duration-200">
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-secondary-500 text-sm font-body leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}